import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePagination = ({ defaultPage = 1, defaultPageSize = 10 } = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const getPageFromUrl = () => {
    const pageParam = searchParams.get('page');
    const page = parseInt(pageParam, 10);
    return isNaN(page) || page < 1 ? defaultPage : page;
  };
  
  const getPageSizeFromUrl = () => {
    const sizeParam = searchParams.get('size');
    const size = parseInt(sizeParam, 10);
    return isNaN(size) || size < 1 ? defaultPageSize : size;
  };
  
  const [currentPage, setCurrentPage] = useState(getPageFromUrl());
  const [pageSize, setPageSize] = useState(getPageSizeFromUrl());
  
  useEffect(() => {
    setCurrentPage(getPageFromUrl());
    setPageSize(getPageSizeFromUrl());
  }, [searchParams]);
  
  const handlePageChange = (newPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', newPage);
    setSearchParams(newParams);
  };
  
  const handlePageSizeChange = (newPageSize) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('size', newPageSize);
    newParams.set('page', 1);
    setSearchParams(newParams);
  };
  
  return {
    currentPage,
    pageSize,
    setPage: handlePageChange,
    setPageSize: handlePageSizeChange
  };
};